/** @jsx jsx */
import { __assign, __rest } from "tslib";
import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { useTheme } from './theme/Providers';
export var getVariantStyles = function getVariantStyles(theme, variant) {
  var _a, _b, _c;

  var ourBlack = theme.colors.scales.grayShades[11];

  switch (variant) {
    case 'uppercase':
      return css({
        textTransform: 'uppercase',
        fontSize: theme.fontSizes[0],
        fontWeight: 600,
        letterSpacing: '-0.02em',
        color: ourBlack
      });

    case 'body':
      return css({
        fontSize: theme.fontSizes[1],
        color: ourBlack
      });

    case 'paragraph':
      return css({
        fontSize: '1.125rem',
        lineHeight: theme.lineHeights.paragraph,
        letterSpacing: '0.5%',
        fontWeight: theme.fontWeights.body,
        color: ourBlack
      });

    case 'paragraph2':
      return css({
        fontSize: theme.fontSizes[3],
        lineHeight: theme.lineHeights.paragraph2,
        letterSpacing: '0.5%',
        fontWeight: theme.fontWeights.body,
        color: ourBlack
      });

    case 'subtitle':
      return css({
        fontSize: '1.375rem',
        letterSpacing: '0%',
        fontWeight: theme.fontWeights.body,
        lineHeight: theme.lineHeights.subtitle,
        color: ourBlack
      });

    case 'subtitle2':
      return css({
        fontSize: theme.fontSizes[4],
        fontWeight: theme.fontWeights.body,
        letterSpacing: '0.5%',
        lineHeight: theme.lineHeights.subtitle2,
        color: ourBlack
      });

    case 'lead':
      return css({
        fontWeight: 400,
        fontSize: theme.fontSizes[2],
        color: ourBlack
      });

    case 'h6':
      return css({
        fontWeight: theme.fontWeights.heading,
        fontSize: theme.fontSizes[4],
        letterSpacing: '0%',
        lineHeight: theme.lineHeights.heading6,
        color: ourBlack
      });

    case 'h5':
      return css({
        fontWeight: theme.fontWeights.heading,
        fontSize: theme.fontSizes[5],
        letterSpacing: '-0.5%',
        lineHeight: theme.lineHeights.heading5,
        color: ourBlack
      });

    case 'h4':
      return css({
        fontWeight: theme.fontWeights.heading,
        fontSize: theme.fontSizes[6],
        lineHeight: theme.lineHeights.heading4,
        letterSpacing: '-1%',
        color: ourBlack
      });

    case 'h3':
      return css({
        fontWeight: theme.fontWeights.display,
        fontSize: theme.fontSizes[7],
        lineHeight: theme.lineHeights.heading3,
        letterSpacing: '-1.5%',
        color: ourBlack
      });

    case 'h2':
      return css({
        fontWeight: theme.fontWeights.display,
        fontSize: theme.fontSizes[8],
        lineHeight: theme.lineHeights.heading2,
        letterSpacing: '-1.5%',
        color: ourBlack
      });

    case 'h1':
      return css({
        fontWeight: theme.fontWeights.display,
        fontSize: theme.fontSizes[9],
        lineHeight: theme.lineHeights.heading,
        letterSpacing: '-2%',
        color: ourBlack
      });

    case 'display3':
      return css((_a = {
        fontWeight: theme.fontWeights.display,
        fontSize: theme.fontSizes[5],
        lineHeight: theme.lineHeights.heading,
        marginBottom: theme.spaces.sm,
        color: ourBlack
      }, _a[theme.mediaQueries.md] = {
        fontSize: theme.fontSizes[6]
      }, _a));

    case 'display2':
      return css((_b = {
        fontWeight: theme.fontWeights.display,
        fontSize: theme.fontSizes[6],
        lineHeight: theme.lineHeights.heading,
        marginBottom: theme.spaces.sm,
        color: ourBlack
      }, _b[theme.mediaQueries.md] = {
        fontSize: theme.fontSizes[7]
      }, _b));

    case 'display1':
      return css((_c = {
        fontWeight: theme.fontWeights.display,
        fontSize: theme.fontSizes[7],
        lineHeight: theme.lineHeights.heading,
        marginBottom: theme.spaces.sm,
        color: ourBlack
      }, _c[theme.mediaQueries.md] = {
        fontSize: theme.fontSizes[8]
      }, _c));

    case 'button':
      return css({
        fontWeight: theme.fontWeights.heading,
        fontSize: theme.fontSizes[3],
        lineHeight: theme.lineHeights.button,
        letterSpacing: '0.5%',
        color: ourBlack
      });

    case 'caption':
      return css({
        fontWeight: theme.fontWeights.heading,
        fontSize: theme.fontSizes[1],
        lineHeight: theme.lineHeights.caption,
        letterSpacing: '0.5%',
        color: ourBlack
      });

    case 'caption2':
      return css({
        fontWeight: theme.fontWeights.body,
        fontSize: theme.fontSizes[0],
        lineHeight: theme.lineHeights.caption2,
        letterSpacing: '1%',
        color: ourBlack
      });

    case 'label':
      return css({
        fontWeight: theme.fontWeights.body,
        fontSize: theme.fontSizes[2],
        letterSpacing: '0.5%',
        lineHeight: theme.lineHeights.label,
        color: ourBlack
      });

    case 'label2':
      return css({
        fontWeight: theme.fontWeights.body,
        fontSize: theme.fontSizes[1],
        lineHeight: theme.lineHeights.label2,
        letterSpacing: '0.5%',
        color: ourBlack
      });
  }

  return null;
};
var element = {
  display1: 'h1',
  display2: 'h1',
  display3: 'h1',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  uppercase: 'p',
  subtitle: 'span',
  subtitle2: 'span',
  body: 'p',
  paragraph: 'p',
  paragraph2: 'p',
  hidden: 'span',
  lead: 'p',
  button: 'span',
  caption: 'p',
  caption2: 'p',
  label: 'p',
  label2: 'p'
};

var basicStyles = function basicStyles(theme) {
  return {
    base: css({
      boxSizing: 'border-box',
      margin: 0,
      fontWeight: theme.fontWeights.body,
      lineHeight: theme.lineHeights.body,
      fontFamily: theme.fonts.base,
      fontSize: theme.fontSizes[1],
      WebkitFontSmoothing: 'antialiased',
      WebkitTextSizeAdjust: 'none'
    }),
    noGutter: css({
      marginBottom: 0
    }),
    noWrap: css({
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }),
    muted: css({
      color: theme.colors.text.muted
    }),
    left: css({
      textAlign: 'left'
    }),
    right: css({
      textAlign: 'right'
    }),
    center: css({
      textAlign: 'center'
    }),
    justify: css({
      textAlign: 'justify'
    })
  };
};

export var Text = function Text(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'body' : _b,
      tag = _a.tag,
      _c = _a.wrap,
      wrap = _c === void 0 ? true : _c,
      _d = _a.gutter,
      gutter = _d === void 0 ? true : _d,
      muted = _a.muted,
      component = _a.component,
      left = _a.left,
      right = _a.right,
      center = _a.center,
      justify = _a.justify,
      other = __rest(_a, ["variant", "tag", "wrap", "gutter", "muted", "component", "left", "right", "center", "justify"]);

  var Component = component ? component : !tag ? element[variant] : tag;
  var theme = useTheme();
  var variantStyles = React.useMemo(function () {
    return getVariantStyles(theme, variant);
  }, [theme, variant]);
  var styles = React.useMemo(function () {
    return basicStyles(theme);
  }, [theme]);
  return jsx(Component, __assign({
    css: [styles.base, !wrap && styles.noWrap, muted && styles.muted, variantStyles, !gutter && styles.noGutter, left && styles.left, right && styles.right, center && styles.center, justify && styles.justify]
  }, other));
};